import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  open(event) {
    event.preventDefault()

    fetch(this.urlValue, { headers: { 'X-Dialog-Request': 'true' } })
      .then(response => response.text())
      .then(html => this.#openDialog(html))
  }

  #openDialog(html) {
    window.miPopbox = new Dialog(html, {
      title: 'Editar plantilla personalizada',
      closingx: true,
      size: 'large',
      runscripts: ''
    })

    requestAnimationFrame(() => {
      const form = document.querySelector('.popbox form[action*="mail_template"], dialog-modal form[action*="mail_template"]')
      if (form) this.#interceptFormSubmit(form)
    })
  }

  #interceptFormSubmit(form) {
    form.addEventListener('submit', (event) => {
      event.preventDefault()

      if (typeof CKEDITOR !== 'undefined') {
        for (const name in CKEDITOR.instances) CKEDITOR.instances[name].updateElement()
      }

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: {
          'X-Dialog-Request': 'true',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
        }
      }).then(response => {
        if (response.ok) {
          if (window.miPopbox) window.miPopbox.destroy()
        } else {
          response.text().then(html => {
            if (window.miPopbox) window.miPopbox.destroy()
            this.#openDialog(html)
          })
        }
      })
    })
  }
}
